import { Box } from '@amzn/ring-ui-react-components';
import { EventMediaVideo } from 'src/shared/components/EventMediaVideo';

export interface VideoPlayerProps {
  url: string;
  handleError?: () => void;
}

export const VideoPlayer = ({ handleError, url }: VideoPlayerProps) => (
  <Box
    cursor="pointer"
    pb={{ base: 2, m: 4 }}
    overflow="hidden"
    position="relative"
    width="100%"
    zIndex={0}
  >
    <EventMediaVideo
      src={url}
      onError={handleError}
      data-testid="media-video"
    />
  </Box>
);
